import React from "react";
import batman from "../../assets/batman.gif";

/**
 * react logo spinner as loading indicator
 * @returns {*}
 * @constructor
 */
const Spin = () => <img src={batman} className="spinner" alt="logo" />;

export default Spin;